import { defineStore } from "pinia";

export const useAppNotificationStore = defineStore("appNotification", {
  state: () => ({
    message: null,
    variant: "danger",
  }),

  actions: {
    success(message) {
      this.message = message;
      this.variant = "success";
    },

    error(message) {
      this.message = message;
      this.variant = "danger";
    },

    clear() {
      this.message = null;
      this.variant = "danger";
    },
  },
});
